var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLayoutArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 31,
    viewBox: "0 0 11 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_5687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9.53674e-06 11.58V9.05004L5.36999 14.42L10.74 9.05004V11.58L6.62999 15.68L6.63999 15.69L5.36999 16.95L4.09999 15.69L4.10999 15.68L-9.53674e-06 11.58Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.53674e-06 2.53003V2.47955e-05L5.36999 5.37002L10.74 2.47955e-05V2.53003L5.36999 7.90002L-9.53674e-06 2.53003Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.53674e-06 25.28V22.76L5.36999 28.13L10.74 22.76V25.28L6.62999 29.39L6.63999 29.4L5.36999 30.66L4.09999 29.4L4.10999 29.39L-9.53674e-06 25.28Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.53674e-06 16.24V13.7L5.36999 19.07L10.74 13.7V16.24L5.36999 21.61L-9.53674e-06 16.24Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_5687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.74,
    height: 30.66,
    fill: "white",
    transform: "translate(10.74 30.66) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLayoutArrowDown);
export default __webpack_public_path__ + "static/media/icon-layout-arrow-down.a524be90e62c0da29940dae8e374be80.svg";
export { ForwardRef as ReactComponent };